export const RISK_REGISTER_MAX_ATTACHMENTS = 20;
export const RISK_REGISTER_ATTACHMENT_MAX_FILE_SIZE_MB = 50;
export const RISK_REGISTER_ATTACHMENT_FILE_TYPES = ['pdf', 'jpg', 'jpeg', 'png', 'xlsx', 'xls', 'csv', 'docx', 'doc'];
